
import React from 'react';
 
import ReactDOM from 'react-dom';
import { Layout}    from 'element-react';
import FeasComponents from '../render/FeasComponents.js'
 

import KeeVue from '../base/KeeVue.js'
 
 


export default class FsRow extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				isShow: false,
				randId: this.getRandString(),
			 
			}
		
}

componentWillMount(){
			var that = this;
			this.registComponent();
		 
		}
onCommand=(cmdName, item, po, thisForm, parentForm)=> {
		this.$emit("command", cmdName, item, po, thisForm, parentForm);
	}
	onChanged=(ret)=> {
		this.$emit("changed", ret);
	}
		 
		
  render(){
	  var style=JSON.parse(JSON.stringify(this.props.component.style));
	  if((this.props.component.visiable != false  ) || this.props.debug == true)
	  {
	  	style.display=this.props.component.style.display;
	  }
	  else
	  {
	  	style.display="none";
	  } 
	  
  return( 
  <div>
    <Layout.Row className={`el-row`} style={style}  >
	{
		this.props.component.child&&this.props.component.child.length>0&&<FeasComponents  components={this.props.component.child} query={this.props.query}
		parentViewName={this.props.parentViewName} 
		po={this.props.po} 
		keePage={this.props.keePage} 
		
		thisForm={this.props.thisForm}
		 parentForm={this.props.parentForm} 
		  name={this.props.name}
		  editable={this.props.editable} 
		   onchanged={this.onChanged}
		   onCommand={this.onCommand}
		   
		   debug={this.props.debug} 
		></FeasComponents>
	}
		
	</Layout.Row>
  </div>
  );}
 }
